import React from 'react';
import { CreditCard } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050810] py-12 border-t border-white/5" data-id="element-27">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-28">
        <div className="flex flex-col items-center gap-6 text-center" data-id="element-29">
          <div className="font-playfair text-2xl font-black text-gradient-gold" data-id="element-30">
            SOS Reflujo 11 PM
          </div>

          <div className="flex gap-3 items-center flex-wrap justify-center text-text-muted" data-id="element-31">
            <CreditCard className="w-6 h-6" data-id="element-32" />
            <span className="text-sm font-medium" data-id="element-33">Pago 100% Seguro</span>
          </div>

          <div className="flex gap-6 flex-wrap justify-center" data-id="element-34">
            <a href="#" className="text-text-muted text-sm no-underline transition-colors hover:text-accent" data-id="element-35">
              Términos y Condiciones
            </a>
            <a href="#" className="text-text-muted text-sm no-underline transition-colors hover:text-accent" data-id="element-36">
              Política de Privacidad
            </a>
            <a href="#" className="text-text-muted text-sm no-underline transition-colors hover:text-accent" data-id="element-37">
              Política de Reembolso
            </a>
            <a href="#" className="text-text-muted text-sm no-underline transition-colors hover:text-accent" data-id="element-38">
              Contacto
            </a>
          </div>

          <p className="text-text-muted text-xs max-w-3xl leading-relaxed" data-id="element-39">
            <strong data-id="element-40">Aviso Legal:</strong> Este producto es de carácter educativo
            e informativo. No reemplaza la evaluación, diagnóstico ni
            tratamiento médico profesional. Si presentas síntomas graves como
            dolor intenso, dificultad para tragar, sangrado, pérdida de peso
            inexplicada o cualquier condición gastrointestinal diagnosticada,
            consulta con tu médico antes de aplicar cualquier protocolo. Los
            resultados individuales pueden variar.
          </p>

          <p className="text-white/20 text-xs" data-id="element-41">
            © {new Date().getFullYear()} Hugo Pagano — SOS Reflujo 11 PM. Todos
            los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}